import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { ref, computed, onMounted, watch, markRaw } from 'vue';
import { useI18n } from 'vue-i18n';
import chapters from '@/store/data';
import useChapterState from '@/store/modules/useChapterState';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterData',
  setup(__props) {

const { t } = useI18n();
const { state } = useChapterState();

const components = ref([]);

const currentComponents = computed(() => {
  return components.value;
});

const getPaddingTop = (index: number) => {
  const currentComponent = currentComponents.value[index];
  const currentColor = currentComponent.data?.backgroundColor ? currentComponent.data?.backgroundColor : 'black';
  if (index == 0) {
    return 'black' === currentColor ? '' : 'Section--Top'
  } else if (index > 0) {
    const previousComponent = currentComponents.value[index - 1];
    const previousColor = previousComponent.data?.backgroundColor ? previousComponent.data?.backgroundColor : 'black';

    return previousColor === currentColor ? '' : 'Section--Top'
  }

  return ''
};
const getPaddingBottom = (index: number) => {
  if (index < currentComponents.value.length - 1) {
    const nextComponent = currentComponents.value[index + 1];
    const currentComponent = currentComponents.value[index];

    const nextColor = nextComponent.data?.backgroundColor ? nextComponent.data?.backgroundColor : 'black';
    const currentColor = currentComponent.data?.backgroundColor ? currentComponent.data?.backgroundColor : 'black';

    console.log('nextComponent.component', nextComponent.componentName)

    return nextComponent.componentName === 'NextChapter' ? 'Section--Bottom' : (nextColor === currentColor ? '' : 'Section--Bottom')
  }

  return ''
};

const translateData = (data: any) => {
  const translateRecursive = (obj: any): any => {
    // console.log('translateRecursive', obj)
    if (typeof obj === 'string') {
      return t(obj);
    } else if (Array.isArray(obj)) {
      return obj.map(translateRecursive);
    } else if (typeof obj === 'object' && obj !== null) {
      const translatedObj = {};
      for (const key in obj) {
        translatedObj[key] = translateRecursive(obj[key]);
      }
      return translatedObj;
    }
    return obj;
  };

  return translateRecursive(data);
};

const loadChapter = async (chapterNumber: number) => {
  console.log(`Loading chapter: ${chapterNumber}`);
  const chapter = chapters[chapterNumber];

  if (!chapter) {
    console.error(`Chapter ${chapterNumber} not found.`);
    return;
  }

  const componentPromises = chapter.content.map(async (item) => {
    const componentModule = await import(`@/components/slices/${item.component}.vue`);
    return {
      ...item,
      component: markRaw(componentModule.default),
      componentName: item.component
    };
  });

  try {
    const resolvedComponents = await Promise.all(componentPromises);
    components.value = resolvedComponents;
  } catch (error) {
    console.error('Error loading chapter:', error);
  }
};

onMounted(() => {
  loadChapter(state.chapterToLoad);
});

// watch(() => state.activeIndex, (newChapter) => {
//   loadChapter(newChapter);
// });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["Chapter", { 'Chapter--loading': _unref(state).isLoading }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentComponents.value, (item, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), _mergeProps({
        key: index,
        ref_for: true
      }, translateData(item.data), {
        class: ["Section", [ getPaddingTop(index), getPaddingBottom(index) ]],
        id: `section-${ index+1 }`,
        index: index
      }), null, 16, ["class", "id", "index"]))
    }), 128))
  ], 2))
}
}

})